// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__A8ouB","content":"styles_content__pYYKy","back":"styles_back__u50Ow"};